import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { jwtDecode } from 'jwt-decode';
import { API_URL } from "../../config";
import * as XLSX from "xlsx";
import DatePicker from "../../components/Datapicker";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'
import { MdOutlineDoneAll, MdClose } from "react-icons/md";
import Tooltip from "@mui/material/Tooltip";
import { logAuditUI } from "../../utils/auditLogger";

dayjs.extend(utc);
dayjs.tz.guess();

function DashboardCard27() {

  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tabletotalData, setTabletotalData] = useState([]);
  const [columnFilterVisibility, setColumnFilterVisibility] = useState({});
  const [dropdownSearch, setDropdownSearch] = useState({});
  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showGrid, setShowGrid] = useState(true);
  const [TotalPerPage, setTotalItemsPerPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(TotalPerPage / itemsPerPage);
  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
  };
  const [startDate, setStartDate] = useState(getCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const token = localStorage.getItem('jwtToken');

  useEffect(() => {
    if (user?.userId) {
      const timer = setTimeout(() => {
        setShowGrid(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [user?.userId]);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }

    logAuditUI({
      actionType: 'VIEW_LIST',
      module: 'Timetracking',
      description: 'A vizualizat raportul de activități reprezentanți medicali / timetracking',
    });
  }, []);

  const fetchManageData = async () => {
    try {
      setLoading(true);

      setTableData([])
      const response1 = await axios.get(`${API_URL}/api/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const resp = await axios.get(`${API_URL}/api/manageuser`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      let val;
      let val1;
      let list;
      if (user?.role === 'Admin') {
        val = response1.data.map((i) => i.user_name_surname);
        val1 = response1.data.map((i) => i.user_name_surname);
      } else if (user?.role === 'Manager') {
        const ans = [
          ...resp.data
            .filter(item => item.manager_user_id === user?.userId)
            .map(item => item.subordinate_user_id),
          user.userId
        ];

        list = ans;
        const subordinateNames = response1.data
          .filter(item => ans.includes(item.user_id))
          .map(item => item.user_name_surname.trim());

        const currentUserNames = response1.data
          .filter(item => item.login === user?.username)
          .map(item => item.user_name_surname.trim());

        val = subordinateNames
        val1 = currentUserNames;
      }
      else {
        const ans = [
          ...resp.data
            .filter(item => item.subordinate_user_id === user?.userId)
            .map(item => item.manager_user_id),
          user?.userId
        ];

        const currentUserNames = response1.data
          .filter(i => i.user_id === user?.userId)
          .map(user => user.user_name_surname.trim());

        const subordinateNames = response1.data
          .filter(item => ans.includes(item.user_id))
          .map(item => item.user_name_surname.trim());

        val = currentUserNames;
        val1 = subordinateNames;
        list = [user?.userId];
      }

      const response = await axios.get(`${API_URL}/api/planning-report`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          manager: val1.map(name => name.trim()),
          user_name_surname: val.map(name => name.trim()),
          start_date: startDate,
          end_date: endDate,
          page: currentPage,
          per_page: itemsPerPage,
          filters: JSON.stringify(filters),
          manager_user_id: list
        },
      });
      const { data, total } = response.data;

      setData(data);

      setTotalItemsPerPage(total);

    } catch (error) {
      console.error("Error fetching manage data:", error);
      setData([]);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(data)
    setTableData(data)
  }, [data]);

  useEffect(() => {
    if (user?.userId) {
      fetchManageData();
    }
  }, [user, startDate, endDate, currentPage, itemsPerPage, filters]);

  const handleExportToExcel = () => {
    const exportData = tableData.map((customer) => ({
      "Manager": customer.manager || "-",
      "Nume utilizator": customer.user_name_surname || "-",
      "Data": customer.date && dayjs(customer.date).isValid()
        ? dayjs(customer.date).format('DD-MM-YYYY')
        : "-",
      "Tip": customer.type || "-",
      "Alt tip activitate": customer.type_other_activity || "-",
      "Tip institutie": customer.tip_institutie || "-",
      "Instituție": customer.institutie || "-",
      "Adresă": customer.adresa || "-",
      "Regiune": customer.regiunea || "-",
      "Raion": customer.raion || "-",
      "Oraș/Sat": customer.oras_sat || "-",
      "Cod Inst. 1C": customer.cod_inst_1C || "-",
      "Cod Adresă 1C": customer.cod_adrs_1C || "-",
      "Doctor": customer.doctor || "-",
      "Specialitate": customer.specialitatea || "-",
      "Materiale": customer.materiale || "-",
      "Produse": customer.produse || "-",
      "Cod Produse 1C": customer.cod_produse_1C || "-",
      "Număr persoane": customer.nr_pers || "-",
      "Număr vizite": customer.nr_vizite || "-",
      "Planificat": customer.planificat || "-",
      "Validat": customer.validat || "-"
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Raport Planificari");

    const colWidths = [
      { wch: 20 }, // Manager
      { wch: 25 }, // Nume utilizator
      { wch: 12 }, // Data
      { wch: 15 }, // Tip
      { wch: 20 }, // Alt tip activitate
      { wch: 25 }, // Instituție
      { wch: 30 }, // Adresă
      { wch: 15 }, // Regiune
      { wch: 15 }, // Raion
      { wch: 15 }, // Oraș/Sat
      { wch: 15 }, // Cod Inst. 1C
      { wch: 15 }, // Cod Adresă 1C
      { wch: 20 }, // Doctor
      { wch: 20 }, // Specialitate
      { wch: 20 }, // Materiale
      { wch: 20 }, // Produse
      { wch: 15 }, // Cod Produse 1C
      { wch: 15 }, // Număr persoane
      { wch: 15 }, // Număr vizite
      { wch: 12 }, // Planificat
      { wch: 12 }  // Validat
    ];

    worksheet['!cols'] = colWidths;

    const fileName = `planificari_${dayjs().format('YYYY-MM-DD')}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  const toggleRowSelection = (index) => {
    setSelectedIndex(selectedIndex === index ? null : index);
  };

  const toggleColumnFilter = (columnKey) => {
    setColumnFilterVisibility(prev => ({
      ...prev,
      [columnKey]: !prev[columnKey]
    }));
  };

  const handleFilterChange = (columnKey, value) => {
    setFilters(prev => ({
      ...prev,
      [columnKey]: value
    }));
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const filteredData = useMemo(() => {
    let result = [...tableData];

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        result = result.filter(item => {
          if (key === 'type') {
            return String(item[key]) === value;
          }
          return String(item[key]).toLowerCase().includes(value.toLowerCase());
        });
      }
    });

    if (sortConfig.key) {
      result.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    return result;
  }, [tableData, filters, sortConfig]);

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        setLoading(true);

        const response1 = await axios.get(`${API_URL}/api/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const resp = await axios.get(`${API_URL}/api/manageuser`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        let val;
        let val1;
        let list;
        if (user?.role === 'Admin') {
          val = response1.data.map((i) => i.user_name_surname);
          val1 = response1.data.map((i) => i.user_name_surname);
        } else if (user?.role === 'Manager') {
          const ans = [
            ...resp.data
              .filter(item => item.manager_user_id === user?.userId)
              .map(item => item.subordinate_user_id),
            user.userId
          ];

          list = ans;
          const subordinateNames = response1.data
            .filter(item => ans.includes(item.user_id))
            .map(item => item.user_name_surname.trim());

          const vvv = response1.data
            .filter(item => ans.includes(item.user_id));

          const currentUserNames = response1.data
            .filter(item => item.login === user?.username)
            .map(item => item.user_name_surname.trim());

          val = subordinateNames;
          val1 = currentUserNames;
        }
        else {
          const ans = [
            ...resp.data
              .filter(item => item.subordinate_user_id === user?.userId)
              .map(item => item.manager_user_id),
            user?.userId
          ];

          const currentUserNames = response1.data
            .filter(i => i.user_id === user?.userId)
            .map(user => user.user_name_surname.trim());

          const subordinateNames = response1.data
            .filter(item => ans.includes(item.user_id))
            .map(item => item.user_name_surname.trim());

          val = currentUserNames;
          val1 = subordinateNames;
          list = [user?.userId];
        }

        const response = await axios.get(`${API_URL}/api/planning-report-filters`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            start_date: startDate,
            end_date: endDate,
            manager: val1.map(name => name.trim()),
            user_name_surname: val.map(name => name.trim()),
            manager_user_id: list,
          },
        });
        setFilterOptions(response.data.filters);
      } catch (err) {
        console.error("Failed to fetch filter options:", err);
      }
      finally {
        setLoading(false);
      }
    };

    if (startDate && endDate && user?.userId) {
      fetchFilterOptions();
    }
  }, [startDate, endDate, user]);


  const getUniqueValues = (key) => {
    if (key === 'type') {
      return ['Raportat', 'Planificat'];
    }
    return filterOptions[key] || [];
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        setLoading(true);

        const response1 = await axios.get(`${API_URL}/api/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const resp = await axios.get(`${API_URL}/api/manageuser`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        let val;
        let val1;
        let list;
        if (user?.role === 'Admin') {
          val = response1.data.map((i) => i.user_name_surname);
          val1 = response1.data.map((i) => i.user_name_surname);
        } else if (user?.role === 'Manager') {
          const ans = [
            ...resp.data
              .filter(item => item.manager_user_id === user?.userId)
              .map(item => item.subordinate_user_id),
            user.userId
          ];


          const subordinateNames = response1.data
            .filter(item => ans.includes(item.user_id))
            .map(item => item.user_name_surname.trim());

          const currentUserNames = response1.data
            .filter(item => item.login === user?.username)
            .map(item => item.user_name_surname.trim());

          val = subordinateNames
          val1 = currentUserNames;
          list = ans;

        }
        else {
          const ans = [
            ...resp.data
              .filter(item => item.subordinate_user_id === user?.userId)
              .map(item => item.manager_user_id),
            user?.userId
          ];

          const currentUserNames = response1.data
            .filter(i => i.user_id === user?.userId)
            .map(user => user.user_name_surname.trim());

          const subordinateNames = response1.data
            .filter(item => ans.includes(item.user_id))
            .map(item => item.user_name_surname.trim());

          val = currentUserNames;
          val1 = subordinateNames;
          list = [user?.userId];
        }

        const response = await axios.get(`${API_URL}/api/planning-report-total`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            start_date: startDate,
            end_date: endDate,
            manager: val1.map(name => name.trim()),
            user_name_surname: val.map(name => name.trim()),
            manager_user_id: list,

          },
        });
        setTabletotalData(response.data)
      } catch (err) {
        console.error("Failed to fetch filter options:", err);
      }
      finally {
        setLoading(false);
      }
    };

    if (startDate && endDate && user?.userId) {
      fetchFilterOptions();
    }
  }, [startDate, endDate, user]);

  const itemsPerPage1 = 15;
  const [currentPage1, setCurrentPage1] = useState(1);
  const totalPages1 = Math.ceil(tabletotalData.length / itemsPerPage1);
  const currentItems = tabletotalData.slice(
    (currentPage1 - 1) * itemsPerPage1,
    currentPage1 * itemsPerPage1
  );


  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl ">
          <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex justify-between items-center">
            <h2 className="font-semibold text-gray-800 dark:text-gray-100">Raport activitati reprezentanti medicali</h2>

            <div className="flex gap-2">
              <div className="relative w-full mt-3">
                <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                  Perioada: De la..
                </label>
                <DatePicker
                  selectedDate={startDate}
                  handleDateChange={handleStartDateChange}
                />
              </div>

              <div className="relative w-full mt-3">
                <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                  Perioada: Pana la..
                </label>
                <DatePicker
                  selectedDate={endDate}
                  handleDateChange={handleEndDateChange}
                />
              </div>
            </div>
          </header>

          <div className="p-3" >
            <div className="//overflow-y-auto" >
              <table className="table-auto w-full dark:text-gray-300">
                <thead className="text-xs uppercase text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                  <tr>
                    {[
                      { key: 'idx', label: 'Index' },
                      { key: 'manager', label: 'Nume prenume, manager' },
                      { key: 'user_name_surname', label: 'Nume prenume, utilizator' },
                      { key: 'date', label: 'Data' },
                      { key: 'type', label: 'Statut activitate' },
                      { key: 'type_other_activity', label: 'Tip alte activitati' },
                      { key: 'institutie', label: 'Instituție' },
                      { key: 'oras_sat', label: 'Oras/Sat' },
                      { key: 'doctor', label: 'Doctor' }
                    ].map(column => {
                      const isFiltered = filters[column.key]?.length > 0;

                      return (
                        <th key={column.key} className="p-2 relative overflow-visible">
                          <div className="font-semibold text-center flex justify-center items-center">
                            <span
                              className="cursor-pointer hover:underline"
                              onClick={() => handleSort(column.key)}
                            >
                              {column.label}
                            </span>
                            {column.key !== 'idx' && (
                              <button
                                onClick={() => toggleColumnFilter(column.key)}
                                className={`ml-2 hover:text-gray-700 dark:hover:text-gray-300 ${columnFilterVisibility[column.key] || isFiltered
                                  ? 'text-violet-500'
                                  : 'text-gray-500'
                                  }`}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>

                          {columnFilterVisibility[column.key] && (
                            <div className="absolute top-full left-0 right-0 bg-white dark:bg-gray-800 shadow-xl border border-gray-200 dark:border-gray-700 rounded mt-1 z-50">
                              <input
                                type="text"
                                placeholder={`Filtrează ${column.label.toLowerCase()}`}
                                className="w-full p-1 text-sm border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                                value={dropdownSearch[column.key] || ''}
                                onChange={(e) => {
                                  setDropdownSearch(prev => ({
                                    ...prev,
                                    [column.key]: e.target.value
                                  }));
                                }}
                              />
                              <div className="mt-2 max-h-40 overflow-y-auto">
                                {getUniqueValues(column.key)
                                  .filter(value =>
                                    value?.toLowerCase().includes((dropdownSearch[column.key] || '').toLowerCase())
                                  )
                                  .map(value => (
                                    <div
                                      key={value}
                                      className="z-10 text-sm p-1 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer"
                                      onClick={() => {
                                        handleFilterChange(column.key, value);
                                        setDropdownSearch(prev => ({ ...prev, [column.key]: '' }));
                                        toggleColumnFilter(column.key);
                                      }}
                                    >
                                      {value}
                                    </div>
                                  ))}
                              </div>
                              <button
                                className="text-xs text-blue-500 mt-2"
                                onClick={() => {
                                  handleFilterChange(column.key, '');
                                  toggleColumnFilter(column.key);
                                }}
                              >
                                Resetează
                              </button>
                            </div>
                          )}
                        </th>
                      )
                    })}
                  </tr>
                </thead>
                {data.length > 0 ? (
                  <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                    {loading ? (
                      <>
                        {[...Array(5)].map((_, idx) => (
                          <tr key={idx}>
                            <td colSpan={8}>
                              <div className="flex flex-row gap-2 py-2 px-2">
                                <div className="flex flex-col gap-2 w-full">
                                  <div className="animate-pulse bg-gray-300 dark:bg-gray-600 w-2/3 h-3 rounded-lg"></div>
                                  <div className="animate-pulse bg-gray-300 dark:bg-gray-600 w-1/2 h-3 rounded-lg"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      filteredData.map((customer, index) => (
                        <React.Fragment key={index}>
                          <tr
                            role="button"
                            onClick={() => toggleRowSelection(index)}
                            className={`${index % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"} hover:bg-gray-200 dark:hover:bg-gray-600`}
                          >
                            <td className="p-2 //whitespace-nowrap text-left">{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                            <td className="p-2 //whitespace-nowrap text-left">{customer.manager}</td>
                            <td className="p-2 //whitespace-nowrap text-center">{customer.user_name_surname}</td>
                            <td className="p-2 whitespace-nowrap text-center">
                              <div title={dayjs(customer.date).isValid() ? dayjs(customer.date).format('DD MMMM YYYY HH:mm') : 'Date unavailable'}>
                                {dayjs(customer.date).isValid() ? dayjs(customer.date).format('DD-MM-YYYY') : '-'}
                              </div>
                            </td>
                            <td className="p-2 //whitespace-nowrap text-center">
                              {
                                customer.type === "Raportat" || customer.type === "Alte activitati" ?
                                  <Tooltip title={"Raportat"} arrow placement="top">
                                    <MdOutlineDoneAll className="text-green-700 text-xl ml-5" />
                                  </Tooltip>
                                  :
                                  <Tooltip title={"Planificat"} arrow placement="top">
                                    <MdClose className="text-red-700 text-xl ml-5" />
                                  </Tooltip>
                              }
                            </td>
                            <td className="p-2 //whitespace-nowrap text-center">{customer.type_other_activity === "-" ? "vizita" : customer.type_other_activity}</td>
                            <td className="p-2 //whitespace-nowrap text-center">{customer.institutie}</td>
                            <td className="p-2 //whitespace-nowrap text-center">{customer.oras_sat}</td>
                            <td className="p-2 //whitespace-nowrap text-center">{customer.doctor}</td>
                          </tr>

                          {selectedIndex === index && (
                            <tr>
                              <td colSpan={9} className="!pt-4 !pb-4 bg-transparent">
                                <div className="rounded-lg bg-gray-100 dark:bg-gray-700 shadow border border-gray-100 dark:border-gray-700 p-4">
                                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Tip institutie</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.tip_institutie || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Adresă</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.adresa || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Regiune</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.regiunea || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Raion</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.raion || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Cod Inst. 1C</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.cod_inst_1C || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Cod Adresă 1C</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.cod_adrs_1C || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Specialitate</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.specialitatea || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Materiale</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.materiale || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Produse</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.produse || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Cod Produse 1C</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.cod_produse_1C || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Număr persoane</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.nr_pers || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Numarul de vizite</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.nr_vizite || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Validat</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.validat || '-'}</p>
                                    </div>
                                    <div>
                                      <p className="text-sm text-gray-500 dark:text-gray-400">Planificat</p>
                                      <p className="text-gray-700 dark:text-gray-300 font-medium">{customer.planificat || '-'}</p>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}

                        </React.Fragment>
                      ))
                    )}
                  </tbody>
                ) : (<h2 className="px-5 py-4 text-gray-600 dark:text-gray-400 ">Nicio inregistrare</h2>)}
              </table>
            </div>

            {TotalPerPage > 5 && (
              <>
                <div className="flex justify-between items-center mb-4 mt-4">
                  <div className="text-sm text-gray-600 dark:text-gray-400">
                    Total: {TotalPerPage} vizite
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-sm text-gray-600 dark:text-gray-400">Arată:</span>
                    <select
                      className="border w-40 border-gray-300 dark:border-gray-600 rounded-md px-3 py-1.5 text-sm bg-white dark:bg-gray-700 dark:text-gray-200"
                      value={itemsPerPage}
                      onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1) }}
                    >
                      <option value={5}>5 pe pagină</option>
                      <option value={10}>10 pe pagină</option>
                      <option value={15}>15 pe pagină</option>
                      <option value={TotalPerPage}>Toate</option>
                    </select>
                  </div>
                </div>
                <div className="flex justify-center mt-4">
                  <button
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 dark:text-gray-100"
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>

                  {currentPage > 3 && (
                    <>
                      <button
                        onClick={() => setCurrentPage(1)}
                        className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                      >
                        1
                      </button>
                      <span className="px-2">...</span>
                    </>
                  )}

                  {Array.from({ length: totalPages }, (_, index) => {
                    const page = index + 1;

                    if (page === currentPage ||
                      (page >= currentPage - 2 && page <= currentPage + 2)) {
                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-4 py-2 text-sm font-medium ${currentPage === page
                            ? "bg-gray-500 text-white"
                            : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600  dark:text-gray-100"}`}
                        >
                          {page}
                        </button>
                      );
                    }
                    return null;
                  })}

                  {currentPage < totalPages - 2 && (
                    <>
                      <span className="px-2">...</span>
                      <button
                        onClick={() => setCurrentPage(totalPages)}
                        className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600  dark:text-gray-100"
                      >
                        {totalPages}
                      </button>
                    </>
                  )}

                  <button
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50  dark:text-gray-100"
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white mt-4 sm:mt-0"
              onClick={() => handleExportToExcel()}
            >
              <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
              </svg>
              <span className="//max-xs:sr-only">Descarca</span>

            </button>

            <h2 className="font-semibold text-gray-800 dark:text-gray-100 mt-5">Date generale</h2>

            <div className="mt-3">
              <table className="overflow-x-auto w-full">
                <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                  <tr>
                    <th className="p-2">
                      <div className="font-semibold text-left">Nume prenume, utilizator</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Total Vizite Planificate</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Total Vizite Raportate</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Total Farmacii</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Total Doctori</div>
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                  {currentItems.map((item, idx) => (

                    <tr
                      key={idx}
                      className={`${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"} hover:bg-gray-200 dark:hover:bg-gray-600`}
                    >
                      <td className="p-2 whitespace-nowrap">
                        <div className="text-left">{item.user_name}</div>
                      </td>
                      <td className="p-2 whitespace-nowrap">
                        <div className="text-center">{item.total_planif}</div>
                      </td>
                      <td className="p-2 whitespace-nowrap">
                        <div className="text-center">{item.total_report}</div>
                      </td>
                      <td className="p-2 whitespace-nowrap">
                        <div className="text-center">{item.total_pharmaci}</div>
                      </td>
                      <td className="p-2 whitespace-nowrap">
                        <div className="text-center">{item.total_doctors}</div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="flex justify-center mt-4 mb-4 //sticky bottom-0">
                <button
                  onClick={() => setCurrentPage1((prev) => Math.max(prev - 1, 1))}
                  className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                  disabled={currentPage1 === 1}
                >
                  Prev
                </button>

                {currentPage1 > 3 && (
                  <>
                    <button
                      onClick={() => setCurrentPage1(1)}
                      className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                    >
                      1
                    </button>
                    <span className="px-2">...</span>
                  </>
                )}

                {Array.from({ length: totalPages1 }, (_, index) => {
                  const page = index + 1;

                  if (
                    page === currentPage1 ||
                    (page >= currentPage1 - 2 && page <= currentPage1 + 2)
                  ) {
                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPage1(page)}
                        className={`px-4 py-2 text-sm font-medium ${currentPage1 === page
                          ? "bg-gray-500 text-white"
                          : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                          }`}
                      >
                        {page}
                      </button>
                    );
                  }
                  return null;
                })}

                {currentPage1 < totalPages1 - 2 && (
                  <>
                    <span className="px-2">...</span>
                    <button
                      onClick={() => setCurrentPage1(totalPages1)}
                      className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                    >
                      {totalPages1}
                    </button>
                  </>
                )}

                <button
                  onClick={() => setCurrentPage1((prev) => Math.min(prev + 1, totalPages1))}
                  className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                  disabled={currentPage1 === totalPages1}
                >
                  Next
                </button>
              </div>
            </div>


          </div>
        </div>
      )}
    </div>
  );
}

export default DashboardCard27;